
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"oeamtc-icon__cityroad","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.5 11v.25a.5.5 0 01-1 0V11H3.58L3 14h4.5v-.5a.5.5 0 011 0v.5H13l-.58-3zM7.5 3.75a.5.5 0 011 0V4h2.58l-.58-3h-2v.5a.5.5 0 01-1 0V1h-2l-.58 3H7.5zM7.2 10l.16-5H6.32l-.42 5h1.3zM8.8 10h1.3l-.42-5H8.64l.16 5zM11.7 10H13l-1-5h-1.04l.74 5zM5.04 5H4l-1 5h1.3l.74-5z"}})])
          )
        }
      }
    